module.exports = __webpack_public_path__ + "static/banner-hp-9c4d38c9dec12613626a2fb0a3905d62.jpg";